import { SchedulerMode, SchedulerJob, SchedulerJobGantt } from "./types";

export function isGanttScheduler(scheduler: SchedulerJob): scheduler is SchedulerJobGantt {
  return scheduler.mode === SchedulerMode.GANTT;
}
